import Default from './default/event_detail_redux';
import Sets from './sets/event_detail_redux';
import Outright from './outright/event_detail_redux';

export default (template, sportId) => {
  if (sportId === 965300) { // Darts
    return Sets;
  }

  switch (template) {
    case 'template_c':
      return Outright;
    case 'template_d':
      return Sets;
    default:
      return Default;
  }
};
